// extracted by mini-css-extract-plugin
module.exports = {"iconCta":"IconCta_iconCta__vkeHF","label":"IconCta_label__iLrTy"};